export default __webpack_public_path__ + "static/2-b1c5a0532e141f1313fe614b326b8b33.jpeg";